const howWeCompareAgentsPath = '/how-we-compare-agents';

type BlogCluster = {
  id: 'fees' | 'register' | 'switching' | 'rules';
  matches: (slug: string) => boolean;
};

const switchingSlugs = new Set([
  'how-to-switch-letting-agents',
  'letting-agent-exit-fees-commission',
  'move-tenancy-deposit-new-letting-agent',
  'letting-agent-handover-checklist',
]);

const rulesSlugs = new Set([
  'section-21-abolished',
  'new-landlord-rules-2026',
  'epc-rating-landlords',
  'making-tax-digital-landlords-letting-agent',
]);

const blogClusters: readonly BlogCluster[] = [
  {
    id: 'fees',
    matches: (slug) =>
      slug.startsWith('letting-agent-fees') ||
      slug === 'how-much-do-letting-agents-charge' ||
      slug === 'tenant-find-vs-full-management',
  },
  {
    id: 'register',
    matches: (slug) => slug.startsWith('register-'),
  },
  {
    id: 'switching',
    matches: (slug) => switchingSlugs.has(slug),
  },
  {
    id: 'rules',
    matches: (slug) =>
      slug.startsWith('renters-rights') || rulesSlugs.has(slug),
  },
];

const relatedPostLimit = 3;

export const howWeCompareAgentsHref = howWeCompareAgentsPath;

export const blogClusterForSlug = (slug: string) =>
  blogClusters.find((cluster) => cluster.matches(slug))?.id;

export const relatedBlogPosts = <Post extends { slug: string }>(
  slug: string,
  posts: readonly Post[],
): Post[] => {
  const cluster = blogClusters.find((candidate) => candidate.matches(slug));
  if (!cluster) {
    return [];
  }

  return posts
    .filter((post) => post.slug !== slug && cluster.matches(post.slug))
    .slice(0, relatedPostLimit);
};
